var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountTemplate01 = function SvgAccountTemplate01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "account_template-01_svg2__a",
    x1: 140.52,
    x2: 4.99,
    y1: 232.17,
    y2: -9.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#account_template-01_svg2__a",
    id: "account_template-01_svg2__b",
    x1: 157.21,
    x2: 21.68,
    y1: 222.81,
    y2: -18.72
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#account_template-01_svg2__a",
    id: "account_template-01_svg2__c",
    x1: 175.01,
    x2: 39.48,
    y1: 212.82,
    y2: -28.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#account_template-01_svg2__a",
    id: "account_template-01_svg2__d",
    x1: 191.7,
    x2: 56.17,
    y1: 203.45,
    y2: -38.07
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#account_template-01_svg2__a",
    id: "account_template-01_svg2__e",
    x1: 139.56,
    x2: 4.04,
    y1: 232.71,
    y2: -8.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#account_template-01_svg2__a",
    id: "account_template-01_svg2__f",
    x1: 137.68,
    x2: 2.15,
    y1: 233.77,
    y2: -7.75
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#account_template-01_svg2__a",
    id: "account_template-01_svg2__g",
    x1: 156.25,
    x2: 20.72,
    y1: 223.34,
    y2: -18.18
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#account_template-01_svg2__a",
    id: "account_template-01_svg2__h",
    x1: 154.37,
    x2: 18.84,
    y1: 224.4,
    y2: -17.12
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#account_template-01_svg2__a",
    id: "account_template-01_svg2__i",
    x1: 174.05,
    x2: 38.52,
    y1: 213.36,
    y2: -28.17
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#account_template-01_svg2__a",
    id: "account_template-01_svg2__j",
    x1: 172.16,
    x2: 36.63,
    y1: 214.42,
    y2: -27.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#account_template-01_svg2__a",
    id: "account_template-01_svg2__k",
    x1: 190.74,
    x2: 55.21,
    y1: 203.99,
    y2: -37.53
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#account_template-01_svg2__a",
    id: "account_template-01_svg2__l",
    x1: 188.85,
    x2: 53.32,
    y1: 205.05,
    y2: -36.47
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#account_template-01_svg2__a",
    id: "account_template-01_svg2__m",
    x1: 175.29,
    x2: 39.76,
    y1: 212.66,
    y2: -28.86
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#account_template-01_svg2__a",
    id: "account_template-01_svg2__n",
    x1: 190.55,
    x2: 55.02,
    y1: 204.1,
    y2: -37.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#account_template-01_svg2__a",
    id: "account_template-01_svg2__o",
    x1: 209.77,
    x2: 74.24,
    y1: 193.31,
    y2: -48.21
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M10 46.67h26.67c5.52 0 10-4.48 10-10V10c0-5.52-4.48-10-10-10H10C4.48 0 0 4.48 0 10v26.67c0 5.52 4.48 10 10 10M6.67 10c0-1.84 1.49-3.33 3.33-3.33h26.67C38.51 6.67 40 8.16 40 10v26.67c0 1.84-1.49 3.33-3.33 3.33H10c-1.84 0-3.33-1.49-3.33-3.33z",
    style: {
      fill: "url(#account_template-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 96.67h26.67c5.52 0 10-4.48 10-10V60c0-5.52-4.48-10-10-10H60c-5.52 0-10 4.48-10 10v26.67c0 5.52 4.48 10 10 10M56.67 60c0-1.84 1.49-3.33 3.33-3.33h26.67c1.84 0 3.33 1.49 3.33 3.33v26.67c0 1.84-1.49 3.33-3.33 3.33H60c-1.84 0-3.33-1.49-3.33-3.33z",
    style: {
      fill: "url(#account_template-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.33 150H140c5.52 0 10-4.48 10-10v-26.67c0-5.52-4.48-10-10-10h-26.67c-5.52 0-10 4.48-10 10V140c0 5.52 4.48 10 10 10M110 113.33c0-1.84 1.49-3.33 3.33-3.33H140c1.84 0 3.33 1.49 3.33 3.33V140c0 1.84-1.49 3.33-3.33 3.33h-26.67c-1.84 0-3.33-1.49-3.33-3.33z",
    style: {
      fill: "url(#account_template-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 153.33h-26.67c-5.52 0-10 4.48-10 10V190c0 5.52 4.48 10 10 10H190c5.52 0 10-4.48 10-10v-26.67c0-5.52-4.48-10-10-10m3.33 36.67c0 1.84-1.49 3.33-3.33 3.33h-26.67c-1.84 0-3.33-1.49-3.33-3.33v-26.67c0-1.84 1.49-3.33 3.33-3.33H190c1.84 0 3.33 1.49 3.33 3.33z",
    style: {
      fill: "url(#account_template-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.67 20H20c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33h-3.33c-1.84 0-3.33 1.49-3.33 3.33S14.83 20 16.67 20",
    style: {
      fill: "url(#account_template-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.67 33.33H30c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H16.67c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#account_template-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.67 70H70c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33h-3.33c-1.84 0-3.33 1.49-3.33 3.33S64.83 70 66.67 70",
    style: {
      fill: "url(#account_template-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.67 83.33H80c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H66.67c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#account_template-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 123.33h3.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H120c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#account_template-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 136.67h13.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H120c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#account_template-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 173.33h3.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H170c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#account_template-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.33 180H170c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h13.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#account_template-01_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.67 20h10c3.68 0 6.67 2.98 6.67 6.67v5.29l-.98-.98a3.332 3.332 0 0 0-4.71 4.71l6.67 6.67c1.3 1.3 3.41 1.3 4.71 0l6.67-6.67a3.332 3.332 0 0 0-4.71-4.71l-.98.98v-5.29c0-7.36-5.97-13.33-13.33-13.33h-10c-1.84 0-3.33 1.49-3.33 3.33S54.84 20 56.68 20Z",
    style: {
      fill: "url(#account_template-01_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.67 73.33h10c3.68 0 6.67 2.98 6.67 6.67v5.29l-.98-.98a3.332 3.332 0 0 0-4.71 4.71l6.67 6.67c1.3 1.3 3.41 1.3 4.71 0l6.67-6.67a3.332 3.332 0 0 0-4.71-4.71l-.98.98V80c0-7.36-5.97-13.33-13.33-13.33h-10c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33Z",
    style: {
      fill: "url(#account_template-01_svg2__n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 123.33h10c3.68 0 6.67 2.98 6.67 6.67v5.29l-.98-.98a3.332 3.332 0 0 0-4.71 4.71l6.67 6.67c1.3 1.3 3.41 1.3 4.71 0l6.67-6.67a3.332 3.332 0 0 0-4.71-4.71l-.98.98V130c0-7.36-5.97-13.33-13.33-13.33h-10c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33Z",
    style: {
      fill: "url(#account_template-01_svg2__o)"
    }
  }));
};
export default SvgAccountTemplate01;